export const initializeEngagementForm = () => {
  let addressInputbox = document.getElementById('address-input-box');
  let inlineFormSell = document.getElementById('pills-sell');
  // let inlineFormBuy = document.getElementById('inline-form-buy');
  let coreLogicIntegration = document.getElementById('daintegration');

  let observer = new MutationObserver((mutationsList, observer) => {
    for (var mutation of mutationsList) {

      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {

        let corelogicForm = document.querySelector('.da_optional_address_form');

        if (corelogicForm) {
          inlineFormSell.appendChild(corelogicForm);
          if (document.querySelector('.hero-search .da_optional_address_form')) {
            // Get references to the radio buttons
            const optionalProperty = document.getElementById('da_optional_property');
            const optionalRental = document.getElementById('da_optional_rental');
            // Get references to the tabs
            const sellTab = document.querySelector('#pills-sell-tab');
            const manageTab = document.querySelector('#pills-manage-tab');

            // Add event listeners for tab clicks
            sellTab.addEventListener('click', function () {
              optionalProperty.checked = true; // Set 'Sell' as checked
            });

            manageTab.addEventListener('click', function () {
              optionalRental.checked = true; // Set 'Manage' as checked
            });
          }
        }

      }
    }
  });

  if (coreLogicIntegration) {
    // Start observing changes to the corelogic integration
    observer.observe(coreLogicIntegration, { childList: true, subtree: true });
  }
}

export const engagementToolTabTitles = () => {

}
